import { useEffect } from "react";

const SUFFIX = "Boardo";

export function usePageTitle(title?: string | null) {
  useEffect(() => {
    document.title = title ? `${title} | ${SUFFIX}` : `Stalo žaidimų turgavietė | ${SUFFIX}`;
  }, [title]);
}
